<template>
  <form-shell
    :title="$t('title')"
    :formsOnShell="formsOnShell"
    :successTexts="successTexts"
    :callbackRequest="createPhysicalWorldOrder"
    :makeBodyToRequest="makeBodyToRequest"
    :preValidation="preValidation"
    @cancel="handleCancel"
  ></form-shell>
</template>
<script>
import { mapActions } from 'vuex'

import { TERMINAL_ROUTES_ENUM } from '@/enums/physical-world.enum'
import FormShell from '@/views/PhysicalWorld/components/FormShell.vue'

import PhysicalWorldManager from '../physical-world.manager'
import {
  FORM_ADDRESS,
  FORM_RECEIVERS,
  FORM_OPEN_HOURS,
  FORM_OBSERVATION
} from './forms-context-terminals.enum'

export default {
  name: 'TerminalUninstallRequest',
  components: {
    FormShell
  },
  data () {
    return {
      formsOnShell: [
        {
          name: 'formTerminalData',
          disabled: true,
          fields: ['serialNumber'],
          initialValues: {
            serialNumber: this.$route?.params?.serialNumber
          }
        },
        FORM_ADDRESS,
        FORM_RECEIVERS,
        FORM_OBSERVATION,
        FORM_OPEN_HOURS
      ],
      successTexts: {
        title: this.$t('success.title'),
        info: this.$t('success.info'),
        content: this.$t('success.content')
      },
      preValidation: {
        component: 'ModalUninstallTerminal',
        props: {
          isLastTerminal: false
        }
      }
    }
  },
  methods: {
    ...mapActions({
      createPhysicalWorldOrder: 'CREATE_PHYSICAL_WORLD_ORDER',
      getTerminals: 'GET_TERMINALS'
    }),
    makeBodyToRequest () {
      return new PhysicalWorldManager().makeBodyToRequestUninstallTerminal()
    },
    handleCancel () {
      this.$router.push({ name: TERMINAL_ROUTES_ENUM.TERMINALS })
    }
  },
  mounted () {
    this.getTerminals().then(res => {
      this.preValidation.props.isLastTerminal =
        res?.content.filter(({ status }) => status === 'installed').length <= 1
    })
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Desinstalação de Maquininha",
      "button": {
        "submit": "Solicitar"
      },
      "success": {
        "title": "Desinstalação de Mmquininha",
        "info": "Desinstalação solicitada com sucesso",
        "content": "Ao clicar no botão abaixo, você será encaminhado para listagem de ordens de serviço para acompanhar sua solicitação."
      }
    },
    "en-US": {
      "title": "Request Uninstall",
      "button": {
        "submit": "Request"
      },
      "success": {
        "title": "Request Uninstall",
        "info": "Uninstall requested successfully",
        "content": "By clicking the button below, you will be redirected to the service order list to track your request."
      }
    }
  }
</i18n>
